import Meta from 'src/components/meta/Meta';

const PropertyTeamMeta = () => <Meta
  title="Meet the Team | BrickX"
  description="One of the benefits of using the BrickX Platform is your access to our Property Team. Who buy properties based on their view of it's quality and potential for growth."
/>;

export default PropertyTeamMeta;
